import * as React from 'react'
import StatisticsVideoArea from "./Components/StatisticsVideoArea"
import useTranslation from '../../hooks/useTranslation';

const titleByTournament = {
    42619: '1990s',   // unique tournament id for the 1990s
    42621: '2000s',   // unique tournament id for the 2000s
    42623: '2010s',   // unique tournament id for the 2010s
    42625: '2020s'    // unique tournament id for the 2020s
}

const ATPVideoLayout = (props) => {
    return (
        <div className="ATPVideoLayout">
            <section>
                <h3>{titleByTournament[props.uniquetournamentid]}</h3>
                <p>{useTranslation('Header_match')} {props.matchid}</p>
            </section>
            <div className="defaultGuiWrapper focusmatchlayout">
                <div className="focusmatch simPlayLayout">
                    <div className="match">
                        <div className="sr-grid sr-row-sr-align-center guiHeader">
                            <div className="sr-cell sr-xs-1-5 sr-show-up-to-m">
                                <div className="sr-content">
                                    <div></div>
                                </div>
                            </div>
                        </div>
                        <div className="sr-grid guiContent">
                            <div className="sr-cell videoWrapper">
                                <div className="sr-content sr-align-center">
                                    <div className="videoContent sr-content">
                                        <StatisticsVideoArea showPlayerProfiles={false} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ATPVideoLayout
